/**
 * 로컬 스토리지에 atom을 저장하는 함수
 */
export const persistAtomAtLocal =
  ({ key }) =>
  ({ setSelf, onSet }) => {
    const storedValue = localStorage.getItem(key);

    if (storedValue != null) {
      setSelf(JSON.parse(storedValue));
    }

    onSet((newValue, _, isReset) => {
      console.log(`Setting new value for ${key}:`, newValue); // 디버깅용
      isReset ? localStorage.removeItem(key) : localStorage.setItem(key, JSON.stringify(newValue));
    });
  };

/**
 * 세션 스토리지에 atom을 저장하는 함수
 */
export const persistAtomAtSession =
  ({ key }) =>
  ({ setSelf, onSet }) => {
    const storedValue = sessionStorage.getItem(key);

    if (storedValue != null) {
      setSelf(JSON.parse(storedValue));
    }

    onSet((newValue, _, isReset) => {
      isReset
        ? sessionStorage.removeItem(key)
        : sessionStorage.setItem(key, JSON.stringify(newValue));
    });
  };
